import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { innerLayoutRoutes } from './inner-routes';
import { outerLayoutRoutes } from './outer-routes';
import InnerLayout from '../views/layout/innerLayout';
import { INNER_ROUTES, OUTER_ROUTES } from '../constants';
import OuterLayout from '../views/layout/outterLayout/index';
import { useIsUser } from '../hooks';

export const Router = () => {

  const {isUser} = useIsUser();
  const location = useLocation();


  return (
    <>
      {!isUser && (
        <OuterLayout>
          <Routes>
            {outerLayoutRoutes.map((route) => (
              <Route
                path={route.path}
                element={route.element}
                key={route.path}
              />
            ))}

            <Route
              path="*"
              element={<Navigate to={OUTER_ROUTES.LOGIN} />}
              key="*"
            />
          </Routes>
        </OuterLayout>
      )}

      {isUser && (
        <InnerLayout>
          <Routes>
            {innerLayoutRoutes.map((route, i: number) => (
              <Route path={route.path} element={route.element} key={i} />
            ))}

            <Route
              path="*"
              element={<Navigate to={INNER_ROUTES.PAYMENT_METHODS} state={location.search ? { query: location.search } : undefined}  />}
              key="*"
            />
          </Routes>
        </InnerLayout>
      )}
    </>
  );
};
